// RFC 4180 CSV generation and download.

// Excel on Windows assumes the system codepage unless a file opens with a UTF-8 BOM, which turns
// en-dashes and accented characters into mojibake.
const UTF8_BOM = '\uFEFF'

// The trailing clauses catch surrounding whitespace, which Excel strips from an unquoted field.
const NEEDS_QUOTING = /[",\r\n]|^\s|\s$/

// Excel, Sheets and LibreOffice evaluate a cell as a formula when its text starts with one of
// these, so tenant-supplied text has to be neutralised before it reaches a spreadsheet.
const FORMULA_TRIGGER = /^[=+\-@\t\r]/

// `=` and `@` (and a leading tab or CR) only ever begin a formula.
const ALWAYS_FORMULA = /^[=@\t\r]/

// A leading `-` or `+` is also the sign of a legitimate value: a negative metric such as `-45m` or
// `-5%`, or a phone number such as `+15551234567`. Those are only dangerous when the rest of the
// value carries something a spreadsheet could execute.
const EXECUTABLE = /[=+*/()!|&^]/

function isFormula(stringValue) {
  if (!FORMULA_TRIGGER.test(stringValue)) return false
  if (ALWAYS_FORMULA.test(stringValue)) return true
  return EXECUTABLE.test(stringValue.slice(1))
}

export function escapeCsvValue(value) {
  let stringValue = value === null || value === undefined ? '' : String(value)

  if (isFormula(stringValue)) {
    stringValue = `'${stringValue}`
  }

  if (!NEEDS_QUOTING.test(stringValue)) return stringValue

  return `"${stringValue.replace(/"/g, '""')}"`
}

export function toCsvRow(values) {
  return values.map(escapeCsvValue).join(',')
}

export function buildCsv(headers, rows) {
  return [toCsvRow(headers), ...rows.map(toCsvRow)].join('\r\n')
}

export function downloadCsv(csvContent, filename) {
  const fileURL = window.URL.createObjectURL(
    new Blob([UTF8_BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
  )
  const fileLink = document.createElement('a')

  try {
    fileLink.href = fileURL
    fileLink.setAttribute('download', filename)
    document.body.appendChild(fileLink)
    fileLink.click()
  } finally {
    // Revoking synchronously after click() cancels an in-flight download in some browsers.
    setTimeout(() => {
      if (fileLink.parentNode) fileLink.parentNode.removeChild(fileLink)
      window.URL.revokeObjectURL(fileURL)
    }, 0)
  }
}
